class GiftWrappingOption extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.input?.addEventListener("change", () => this.updateState(), {
      signal: this.abortController.signal,
    });
    this.updateState();
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  get input() {
    return this.querySelector("[data-gift-wrapping-option]");
  }

  updateState() {
    const input = this.input;

    if (!input) {
      return;
    }

    const productForm = document.getElementById(input.getAttribute("form"));
    const paymentButton = productForm?.querySelector(".shopify-payment-button");

    if (paymentButton) {
      paymentButton.toggleAttribute("hidden", input.checked);
    }
  }
}

if (!window.customElements.get("gift-wrapping-option")) {
  window.customElements.define("gift-wrapping-option", GiftWrappingOption);
}
